// @flow
import React from 'react'
import firebase from 'firebase/app'
import 'firebase/database'
import Lottie from 'react-lottie'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/popup.css'
import './styles.scss'

import iconLove from '../../images/icon-love.svg'
import iconTouching from '../../images/icon-touching.svg'
import iconRomantic from '../../images/icon-romantic.svg'

import animationLove from '../../images/love-animation.json'
import animationTouching from '../../images/touching-animation.json'
import animationRomantic from '../../images/romantic-animation.json'

const loveOptions = {
  loop: false,
  autoplay: true,
  animationData: animationLove,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

const touchingOptions = {
  loop: false,
  autoplay: true,
  animationData: animationTouching,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

const romanticOptions = {
  loop: false,
  autoplay: true,
  animationData: animationRomantic,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export class EmojiReactions extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      loveClicked: false,
      touchingClicked: false,
      romanticClicked: false,
      loveVotes: 0,
      touchingVotes: 0,
      romanticVotes: 0,
      playLoveAnimation: false,
      playTouchingAnimation: false,
      playRomanticAnimation: false
    }

    // Init Firebase
    const config = {
      apiKey: 'AIzaSyDK2K4LgTvb2KcTE6bUMDElqGxYKCLlo-c',
      authDomain: 'emoji-reactions.europe-west1.firebasedatabase.app',
      databaseURL: 'https://emoji-reactions.europe-west1.firebasedatabase.app',
      storageBucket: 'ta-interaktiv.appspot.com'
    }
    if (!firebase.apps.length) {
      // console.log('firebase.apps', firebase.apps)
      firebase.initializeApp(config)
    }
  }

  /* increment in firebase */
  addVote(storyID, reactionID, articleID) {
    const newVote = firebase
      .database()
      .ref(articleID + '/' + storyID + '/' + reactionID)
    newVote.transaction(
      currentVotes => {
        return currentVotes + 1
      },
      (error, committed, snapshot) => {
        if (error) {
          // console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          // console.log('Transaction aborted')
        } else {
          /* transaction complete */
          this.getVotes()
        }
      }
    )
  }

  /* decrement in firebase */
  removeVote(storyID, reactionID, articleID) {
    const newVote = firebase
      .database()
      .ref(articleID + '/' + storyID + '/' + reactionID)
    newVote.transaction(
      currentVotes => {
        return currentVotes - 1
      },
      (error, committed, snapshot) => {
        if (error) {
          // console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          // console.log('Transaction aborted')
        } else {
          /* transaction complete */
          this.getVotes()
        }
      }
    )
  }

  getVotes() {
    // console.log('get votes rom firebase for', this.state.tippID)
    /* firebase request */
    firebase
      .database()
      .ref(this.props.articleID + '/' + this.props.storyID)
      .once('value')
      .then(snapshot => {
        const loveVotes = snapshot.child('love').val()
        const touchingVotes = snapshot.child('touching').val()
        const romanticVotes = snapshot.child('romantic').val()
        this.setState({
          loveVotes: loveVotes || 0,
          touchingVotes: touchingVotes || 0,
          romanticVotes: romanticVotes || 0
        })
      })
    this.getLocalVotes()
    // console.log('update teaser count:', this.props.storyIndex)
  }

  getLocalVotes() {
    const reactions = JSON.parse(localStorage.getItem(this.props.storyID))
    if (reactions !== null) {
      this.setState({
        loveClicked: reactions.love,
        touchingClicked: reactions.touching,
        romanticClicked: reactions.romantic
      })
    }
  }

  reactToStory(reactionID, storyID) {
    // console.log('reactToStory')
    const reactions = JSON.parse(localStorage.getItem(storyID))
    // console.log('stored reactions:', reactions)
    if (reactions !== null) {
      const newReactions = reactions
      newReactions[reactionID] = !reactions[reactionID]
      localStorage.setItem(storyID, JSON.stringify(newReactions))
      if (reactions[reactionID] === false) {
        this.removeVote(storyID, reactionID, this.props.articleID)
      } else {
        this.addVote(storyID, reactionID, this.props.articleID)
        if (reactionID === 'love') {
          this.setState({ playLoveAnimation: true })
        } else if (reactionID === 'touching') {
          this.setState({ playTouchingAnimation: true })
        } else if (reactionID === 'romantic') {
          this.setState({ playRomanticAnimation: true })
        }
      }
    } else {
      const reactionData = {}
      reactionData[reactionID] = true
      localStorage.setItem(storyID, JSON.stringify(reactionData))
      this.addVote(storyID, reactionID, this.props.articleID)
      if (reactionID === 'love') {
        this.setState({ playLoveAnimation: true })
      } else if (reactionID === 'touching') {
        this.setState({ playTouchingAnimation: true })
      } else if (reactionID === 'romantic') {
        this.setState({ playRomanticAnimation: true })
      }
    }
  }

  componentDidMount() {
    this.getVotes()
    this.getLocalVotes()
  }

  render() {
    return (
      <div className='reactions'>
        <div className='animation'>
          <Lottie
            isStopped={!this.state.playLoveAnimation}
            options={loveOptions}
            eventListeners={[
              {
                eventName: 'complete',
                callback: () => this.setState({ playLoveAnimation: false })
              }
            ]}
          />
        </div>
        <div className='animation'>
          <Lottie
            isStopped={!this.state.playTouchingAnimation}
            options={touchingOptions}
            eventListeners={[
              {
                eventName: 'complete',
                callback: () => this.setState({ playTouchingAnimation: false })
              }
            ]}
          />
        </div>
        <div className='animation'>
          <Lottie
            isStopped={!this.state.playRomanticAnimation}
            options={romanticOptions}
            eventListeners={[
              {
                eventName: 'complete',
                callback: () => this.setState({ playRomanticAnimation: false })
              }
            ]}
          />
        </div>
        <div className='label-wrapper'>
          <div
            className={
              this.state.loveClicked ? 'ui label love voted' : 'ui label love'
            }
            onClick={() => this.reactToStory('love', this.props.storyID)}
            data-tooltip='herzerwärmend'
          >
            <img className='icon' src={iconLove} unselectable='on' />
            <span className='count'>{this.state.loveVotes}</span>
          </div>

          <div
            className={
              this.state.touchingClicked
                ? 'ui label touching voted'
                : 'ui label touching'
            }
            onClick={() => this.reactToStory('touching', this.props.storyID)}
            data-tooltip='berührend'
          >
            <img className='icon' src={iconTouching} />
            <span className='count'>{this.state.touchingVotes}</span>
          </div>

          <div
            className={
              this.state.romanticClicked
                ? 'ui label romantic voted'
                : 'ui label romantic'
            }
            onClick={() => this.reactToStory('romantic', this.props.storyID)}
            data-tooltip='aufregend'
          >
            <img className='icon' src={iconRomantic} />
            <span className='count'>{this.state.romanticVotes}</span>
          </div>
        </div>
      </div>
    )
  }
}
